import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'cambodia_transport_home_place_sleep_workers_who_finish'

export const dataPointDefinition = {
  retracedId: 'cambodia_transport_home_place_sleep_workers_who_finish',
  name: 'Cambodia: Transport home or a place to sleep for workers who finish work between 22:00 and 05:00',
  description:
    'This question is specific to Cambodia only. Please consult the Law Overlay for more information on applicable legal requirements.',
  meta: {
    slcpMeta: {
      key: 'wb-wag-128x',
      number: 'WB-WAGE-154-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wb-wag-127',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],fp-bi-7,Cambodia,wb-26,No',
      machineShowHide: '[1],fp-bi-7,30,wb-26,2',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wag-128x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35580,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
